import { createFileRoute } from "@tanstack/react-router";
import CategoriesPage from "@/features/categories/CategoriesPage";
import { requireFeatureEnabled } from "@/features/features";

export const Route = createFileRoute("/_admin/knowledges/categories")({
  beforeLoad: () => requireFeatureEnabled("knowledge_base"),
  component: CategoriesPage,
});
